<div
  bsModal
  #deleteListModal="bs-modal"
  [config]="{
    show: false,
    keyboard: !modalControl.isSaving,
    ignoreBackdropClick: modalControl.isSaving
  }"
  [rlTrapFocus]="{ setReturnFocus: '#edit-list-btn' }"
  (onHidden)="onHidden()"
  class="c-modal modal fade"
  tabindex="-1"
  role="alertdialog"
  aria-labelledby="delete-list-modal-heading"
  aria-describedby="delete-list-modal-status"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <span class="fa-stack fa-5x" aria-hidden="true">
        <i class="fas fa-circle fa-stack-2x icon-bg-danger"></i>
        <i class="fal fa-trash-alt fa-stack-1x text-danger"></i>
      </span>
      <h2
        id="delete-list-modal-heading"
        i18n="@@deleteListModal-heading-deleteList"
        class="qa-archive-list__heading alpha"
      >
        Delete list
      </h2>

      <div
        *ngIf="modalControl.savingError ? true : false"
        class="alert alert-danger qa-delete-list__error"
        role="alert"
      >
        <strong i18n="@@deleteListModal-status-error">Error!</strong>
        <ng-container i18n="@@deleteListModal-status-errorPleaseRetry"
          >There was an error deleting the list. Please try again.</ng-container
        >
      </div>

      <p
        id="delete-list-modal-status"
        class="qa-delete-list__status"
        i18n="@@deleteListModal-status-warningCannotBeUndone"
      >
        Warning, deleted lists cannot be recovered. You cannot undo this
        operation.
      </p>

      <div class="c-modal__footer">
        <button
          [disabled]="modalControl.isSaving"
          (click)="onCancel()"
          type="button"
          class="btn btn-default qa-delete__cancel-button"
          i18n="@@deleteListModal-btn-cancel"
        >
          Cancel
        </button>

        <button
          [disabled]="modalControl.isSaving"
          (click)="onConfirm()"
          type="button"
          class="btn btn-danger qa-delete__confirm-button"
        >
          <span
            *ngIf="modalControl.isSaving"
            class="text-center qa-delete__saving"
            role="status"
          >
            <i
              class="fas fa-spinner-third fa-fw fa-spin"
              aria-hidden="true"
            ></i>
            <span class="sr-only" i18n="@@deleteListModal-spinner-saving"
              >Saving...</span
            >
          </span>
          <ng-container i18n="@@deleteListModal-btn-confirm">
            Delete
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
